/**
 * Collection product-card quick add.
 * One delegated listener; POST /cart/add.js with the first available variant.
 */
(function () {
  if (window.pbCollectionCardAtcBound) return;
  window.pbCollectionCardAtcBound = true;

  var LABEL_IDLE_SHORT = 'Add';
  var LABEL_IDLE_FULL = 'Add to cart';
  var LABEL_BUSY = 'Adding…';
  var LABEL_DONE = 'Added';
  var LABEL_FAIL = 'Try again';
  var DONE_MS = 1600;

  document.addEventListener('click', onDocumentClick);

  function onDocumentClick(event) {
    var btn = event.target.closest('[data-pb-collection-atc]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
    addToCart(btn);
  }

  function getCartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.indexOf('.js') === -1 ? base + '.js' : base;
  }

  function setLabels(btn, shortText, fullText) {
    var shortEl = btn.querySelector('[data-pb-collection-atc-label]');
    var fullEl = btn.querySelector('[data-pb-collection-atc-label-full]');
    if (shortEl) shortEl.textContent = shortText;
    if (fullEl) fullEl.textContent = fullText || shortText;
  }

  function setIdleLabels(btn) {
    setLabels(btn, LABEL_IDLE_SHORT, LABEL_IDLE_FULL);
  }

  function setBusy(btn, busy, label) {
    btn.disabled = busy;
    btn.setAttribute('aria-disabled', busy ? 'true' : 'false');
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.classList.toggle('is-loading', busy);
    if (label) setLabels(btn, label);
  }

  function announce(btn, message) {
    var live = btn.closest('.pb-collection-card__actions');
    live = live && live.querySelector('[data-pb-collection-atc-status]');
    if (!live) return;
    live.textContent = message || '';
  }

  function addToCart(btn) {
    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) {
      announce(btn, 'This product cannot be added from here.');
      return;
    }

    if (btn._pbAtcAbort) btn._pbAtcAbort.abort();
    var abort = new AbortController();
    btn._pbAtcAbort = abort;

    setBusy(btn, true, LABEL_BUSY);
    announce(btn, 'Adding to cart');

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
      signal: abort.signal,
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || !data || data.status) {
          var errMsg =
            (data && (data.description || data.message)) || 'Could not add to cart. Please try again.';
          setBusy(btn, false, LABEL_FAIL);
          announce(btn, errMsg);
          return;
        }

        setBusy(btn, false, LABEL_DONE);
        announce(btn, 'Added to cart');
        refreshCartAndOpen(btn, data);

        window.setTimeout(function () {
          var shortEl = btn.querySelector('[data-pb-collection-atc-label]');
          if (shortEl && shortEl.textContent === LABEL_DONE) setIdleLabels(btn);
        }, DONE_MS);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        setBusy(btn, false, LABEL_FAIL);
        announce(btn, 'Could not add to cart. Check your connection and try again.');
      });
  }

  function refreshCartAndOpen(btn, addResponse) {
    var cartUpdateName =
      typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate
        ? PUB_SUB_EVENTS.cartUpdate
        : 'cart-update';

    if (typeof publish === 'function') {
      publish(cartUpdateName, { source: 'pb-collection-card', cartData: addResponse });
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    window.dispatchEvent(new Event('cart:refresh'));

    var drawer = document.querySelector('cart-drawer');
    if (drawer && addResponse && addResponse.sections && typeof drawer.renderContents === 'function') {
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
      drawer.renderContents(addResponse);
      return;
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(btn);
      return;
    }

    var cartTrigger =
      document.querySelector('#pb-nav-cart') ||
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('a[href$="/cart"]');
    if (cartTrigger) {
      cartTrigger.click();
      return;
    }

    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
})();
